export default __webpack_public_path__ + "static/media/Jason_Crow.0f0f446c.jpg";